import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = (props) => {
  
  //////////////////////
  ///Carousel
  function PrevButton({ onClick }) {
    return <i className="fas fa-chevron-left" onClick={onClick}></i>;
  }
  function NextButton({ onClick }) {
    return <i className="fas fa-chevron-right" onClick={onClick}></i>;
  }
  const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <PrevButton />,
      nextArrow: <NextButton />,
    };

  return(
    <div>
      {(props.images.length > 0) && props.part.subtype == "carousel" ?
          <Slider {...sliderSettings}>
            {props.images.map((image, index) =>
              <div key={index} className="imageHolder">
                {props.buildImage(image.url)}
              </div>
            )}
          </Slider>
      :''}
    </div>
  )
}

export default Carousel;
